var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"}},_vm._l((_vm.segments),function(segment){return _c('o-map-polyline',{key:segment.key,attrs:{"name":segment.name,"path":segment.path,"color":segment.tier.color,"weight":segment.tier.weight,"pane":segment.tier.pane}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }